import React from "react";
import { OnboardingInfo } from "../../graphql/onboarding/onboarding/types/OnboardingInfo";
import { ONBOARDING } from "../../graphql/onboarding/onboarding/query";
import { useLazyQuery, useQuery } from "@apollo/client";
import { useNavigate } from "react-router-dom";
import {
  CheckPaymentStripe,
  CheckPaymentStripeVariables,
} from "../../graphql/onboarding/stripe/types/CheckPaymentStripe";
import { CHECK_PAYMENT_STRIPE } from "../../graphql/onboarding/stripe/query";
import { Payment_Status } from "../../enums/stripe";
import GetId from "./GetId";
import { kyc_status } from "../../enums/kyc";
import Layout from "../Common/NewLayout";
import Header from "../Common/NewLayout/Header";
import { useToastNotifications } from "../../utils/toastUtils";

const GetIdProvider = () => {
  const navigate = useNavigate();
  const { showErrorToast } = useToastNotifications();

  const [checkPayment, { loading: loadingPaiement }] = useLazyQuery<
    CheckPaymentStripe,
    CheckPaymentStripeVariables
  >(CHECK_PAYMENT_STRIPE, {
    variables: { changeStep: true },
    onCompleted: ({ checkPaymentStripe }) => {
      if (checkPaymentStripe !== Payment_Status.PAID) {
        showErrorToast({ description: "payment.stripe.not.paid" });
        redirectToPrevious();
      }
    },
    onError: () => {
      showErrorToast({ description: "check.payment.stripe.status.error" });
      redirectToPrevious();
    },
  });

  const { data: onboarding, loading } = useQuery<OnboardingInfo>(ONBOARDING, {
    fetchPolicy: "network-only",
    onCompleted: () => checkPayment(),
    onError: () =>
      showErrorToast({
        description: "onboarding.retrieving.information.error",
      }),
  });

  const previous = onboarding?.onboardingInfo?.company?.isIndividual
    ? "/manager"
    : "/shareholdersPercent";

  const redirectToPrevious = () => {
    setTimeout(() => navigate(previous), 5000);
  };

  const status = onboarding?.onboardingInfo?.company?.step || null;

  return (
    <Layout
      title="Validez votre identité en toute confiance"
      description="Pour garantir la sécurité de vos données, procédez à une vérification simple et fiable. Ce processus protège votre espace personnel et assure un environnement sécurisé."
      loading={loading || loadingPaiement}
    >
      <Header title="Vérification d'identité" />
      <GetId
        next="/contrat"
        onProcessing={[
          kyc_status.PROCESSING,
          kyc_status.PENDING_REVIEW,
          kyc_status.VALIDATED,
        ].includes(status as kyc_status)}
        previous={previous}
      />
    </Layout>
  );
};

export default GetIdProvider;
